import { ReactNode, useEffect, useRef } from 'react';
import './popup.scss';
import { useGlobalState } from '../../Contexts/globalStateContext';
import { BizButton } from '../Mini/BizButton';
import { useTranslation } from 'react-i18next';

type PopupProps = {
	children: ReactNode;
	title?: string;
	adminPopup?: boolean;
};

const Popup = ({ children, title, adminPopup }: PopupProps) => {
	const { hideModal } = useGlobalState();
	const popupRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		popupRef.current?.focus();

		window.addEventListener('keydown', keyDownHandler);

		return () => {
			window.removeEventListener('keydown', keyDownHandler);
		};
	}, []);

	function closeHandler() {
		hideModal();
	}

	function keyDownHandler(e: globalThis.KeyboardEvent) {
		if (e.key === 'Escape') {
			closeHandler();
		}
	}

	{
		/* why not using a <dialog open> element? */
	}
	return (
		<div className={`biz-popup-wrapper ${adminPopup ? 'admin-primary' : ''}`}>
			<div className='biz-popup' tabIndex={-1} ref={popupRef}>
				<header>
					<div className='popup-title'>{title}</div>
					<div className='popup-close' onClick={closeHandler}>
						<i className='fas fa-times close-icon'></i>
					</div>
				</header>
				<main className='popup-content'>{children}</main>
			</div>
		</div>
	);
};

export default Popup;

export type ConfirmCustomOption = {
	text: string;
	onClick: () => void;
	isDefault?: boolean;
};
export type ConfirmPopupProps = {
	message: string;
	onConfirm: () => void;
	onCancel: () => void;
	legacy?: boolean;
	customOptions?: ConfirmCustomOption[]; //todo actually use
};

export const ConfirmPopup = ({ message, onConfirm, onCancel, legacy }: ConfirmPopupProps) => {
	const { t } = useTranslation();
	return (
		<div className='biz-confirm-popup'>
			<p>{message}</p>
			<div className='biz-confirm-popup-buttons dialog-btn-actions'>
				<BizButton text={t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })} onClick={onCancel} legacy={legacy}></BizButton>
				<BizButton text={t('GLOBAL.OK', { defaultValue: 'Ok' })} onClick={onConfirm} isLead legacy={legacy}></BizButton>
			</div>
		</div>
	);
};
